import { DataObject } from '@shared/models/data-object.model';
const SUPPORTED_USAGES = ['retail', 'office', 'land', 'industrial'];
export const sanitizeReonomyUsages = ({ usages, ...record }: DataObject) => {
  usages = (usages || [])
    .filter(({ ref_property_usage_type_desc }) =>
      SUPPORTED_USAGES.some(supportedType => supportedType === ref_property_usage_type_desc.toLowerCase())
    )
    .map(({ company_contact_role_addresses, ...usage }) => ({
      ...usage,
      company_contact_role_addresses: (company_contact_role_addresses || []).filter(({ company_id }) => !!company_id),
    }));
  return { ...record, usages };
};
